











import {EstateType} from '@/model/api';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class EstateTypeControl extends Vue {
    @Prop({type: Array, default: true})
    public readonly estateTypes: EstateType[];

    private selectedValue: EstateType | null = null;

    @Watch('selectedValue')
    protected emitChange(): void {
        this.$emit('change', this.selectedValue);
    }

    private capitalizeFirstLetter(text: string): string {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
}
